const PLATFORM_KEY = "wirelesspress_device_platform_filter";
const STATE_KEY = "wirelesspress_device_state_filter";
const DEVICE_KEY = "wirelesspress_device_uuid_filter";

export function getPlatformFilter() {
  return localStorage.getItem(PLATFORM_KEY) || "all";
}

export function getStateFilter() {
  return localStorage.getItem(STATE_KEY) || "current";
}

export function getDeviceFilter() {
  return localStorage.getItem(DEVICE_KEY) || "";
}

export function setPlatformFilter(value) {
  localStorage.setItem(PLATFORM_KEY, value || "all");
  notify();
}

export function setStateFilter(value) {
  localStorage.setItem(STATE_KEY, value || "current");
  notify();
}

export function setDeviceFilter(value) {
  if (value) {
    localStorage.setItem(DEVICE_KEY, value);
  } else {
    localStorage.removeItem(DEVICE_KEY);
  }

  notify();
}

export function normalizePlatform(value) {
  const p = String(value || "").toLowerCase();

  if (
    p === "darwin" ||
    p.startsWith("macos") ||
    p.startsWith("mac os")
  ) {
    return "macos";
  }

  if (p.startsWith("windows")) {
    return "windows";
  }

  return "other";
}

export function isFreshTimestamp(value, minutes = 10) {
  if (!value) return false;

  const time = new Date(value).getTime();

  if (!Number.isFinite(time)) return false;

  return Date.now() - time <= minutes * 60 * 1000;
}

export function getOperationalState(device) {
  const lifecycle = String(
    device.lifecycle_state || "active"
  ).toLowerCase();

  if (lifecycle === "decommissioned") {
    return "decommissioned";
  }

  const authoritative = String(
    device.effective_status || ""
  ).toLowerCase();

  if (
    authoritative === "stale" ||
    authoritative === "offline"
  ) {
    return authoritative;
  }

  if (authoritative === "online") {
    return "current";
  }

  return isFreshTimestamp(device.last_seen, 10)
    ? "current"
    : "stale";
}

export function filterDevices(
  devices,
  {
    platform = getPlatformFilter(),
    state = getStateFilter(),
    deviceUuid = getDeviceFilter(),
  } = {}
) {
  return (Array.isArray(devices) ? devices : []).filter(
    (device) => {
      if (
        platform !== "all" &&
        normalizePlatform(device.platform) !== platform
      ) {
        return false;
      }

      if (
        deviceUuid &&
        String(device.device_uuid || "") !==
          String(deviceUuid)
      ) {
        return false;
      }

      const deviceState = getOperationalState(device);

      if (state === "all") {
        return true;
      }

      if (state === "current") {
        return deviceState === "current";
      }

      return deviceState === state;
    }
  );
}

function notify() {
  window.dispatchEvent(
    new Event("wirelesspress-device-filter-change")
  );
}
